import { motion } from "framer-motion";

const COLORS = { blue: "var(--blue)", pink: "var(--pink)", green: "var(--green)", orange: "var(--orange)", purple: "var(--purple)", yellow: "var(--yellow)" };

export const CursorTag = ({ label, color = "blue", className = "", delay = 0, play = true, float = 0 }) => (
  <motion.div
    className={`absolute pointer-events-none select-none ${className}`}
    initial={{ opacity: 0, scale: 0.7 }}
    animate={play ? { opacity: 1, scale: 1, y: [0, -float, 0] } : {}}
    transition={{ opacity: { duration: 0.4, delay }, scale: { duration: 0.4, delay }, y: { duration: 5 + delay, repeat: Infinity, ease: "easeInOut" } }}
    data-testid={`cursor-tag-${color}`}
  >
    <svg width="18" height="20" viewBox="0 0 18 20" className="drop-shadow" aria-hidden>
      <path d="M1 1 L17 9 L9 11 L6 19 Z" fill={COLORS[color]} stroke="var(--ink)" strokeWidth="1.5" strokeLinejoin="round" />
    </svg>
    <span
      className="font-mono text-[0.68rem] uppercase tracking-[0.08em] px-2.5 py-1 rounded-md border-[1.5px] border-[var(--ink)] ml-3 -mt-1 inline-block whitespace-nowrap"
      style={{ background: COLORS[color], color: color === "blue" || color === "orange" ? "#fff" : "var(--ink)" }}
    >
      {label}
    </span>
  </motion.div>
);
